import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '@/lib/firebase';
import {
  buildStaffProfilePhotoPath,
  validateStaffProfilePhotoFile,
} from '@/utils/staffPhoto';

export type StaffProfilePhotoUpload = {
  photoUrl: string;
  storagePath: string;
};

export async function uploadStaffProfilePhoto(
  staffId: string,
  file: File,
): Promise<StaffProfilePhotoUpload> {
  const validationError = validateStaffProfilePhotoFile(file);
  if (validationError) {
    throw new Error(validationError);
  }

  const storagePath = buildStaffProfilePhotoPath(staffId, file);
  const objectRef = ref(storage, storagePath);

  await uploadBytes(objectRef, file, {
    contentType: file.type,
    customMetadata: {
      staffId,
      kind: 'profile',
    },
  });

  const photoUrl = await getDownloadURL(objectRef);
  return { photoUrl, storagePath };
}

export async function getStaffPhotoDownloadUrl(storagePath: string) {
  return getDownloadURL(ref(storage, storagePath));
}
